// extracted by css-extract-rspack-plugin
export default {"footer":"footer-bUqP24","footerLeftButton":"footerLeftButton-sV8Rfs"};